import { Component, OnInit } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
@Component({
  selector: 'shc-payment',
  templateUrl: './payment.page.html',
  styleUrls: ['./payment.page.scss'],
})
export class PaymentPage implements OnInit {

  genderOptions: Array<any> = [
    {
      type: marker('Auth.Form.Male'),
      key: 'male'
    },
    {
      type: marker('Auth.Form.Female'),
      key: 'female'
    },
    {
      type: marker('Auth.Form.Other'),
      key: 'other'
    }
  ];
  constructor() { }

  ngOnInit() { }

}
